module.exports = __webpack_public_path__ + "static/media/logo1.659986ec.png";